import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledProjectLayout = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px;
  padding: 32px;
  background-color: ${COLOR.white};
`;

export const StyledProjectHeader = styled('div')`
  border-bottom: 1px solid #3c3c4329;

  .title-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 420px;
    margin-bottom: 16px;
  }

  .title {
    font-weight: 800;
    font-size: 32px;
    color: ${COLOR.darkGray};
    line-height: 38px;
    letter-spacing: -0.4px;
    vertical-align: middle;
  }

  .content {
    font-weight: 400;
    font-size: 14px;
    color: ${COLOR.label[80]};
    line-height: 20px;
    letter-spacing: -0.4px;
  }
`;
